export interface SmsSessionState {
  authed: boolean;
  exchangingSso: boolean;
  revision: number;
}

export function ssoTokenFromHash(hash: string): string | null {
  return /^#sso=(.+)$/.exec(hash)?.[1] ?? null;
}

export function initialSmsSession(
  token: string | null,
  hash: string,
): SmsSessionState {
  const exchangingSso = !!ssoTokenFromHash(hash);
  return { authed: !!token && !exchangingSso, exchangingSso, revision: 0 };
}

/** Новое поколение гарантирует новую загрузку даже при повторном входе уже авторизованного пользователя. */
export function authenticatedSmsSession(
  previous: SmsSessionState,
): SmsSessionState {
  return {
    authed: true,
    exchangingSso: false,
    revision: previous.revision + 1,
  };
}

export function signedOutSmsSession(
  previous: SmsSessionState,
): SmsSessionState {
  return {
    authed: false,
    exchangingSso: false,
    revision: previous.revision + 1,
  };
}
